import script from "./TariffMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./TariffMain.vue?vue&type=script&setup=true&lang=ts"

import "./TariffMain.vue?vue&type=style&index=0&id=6007ca75&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6007ca75"]])

export default __exports__